import { Component, Input } from '@angular/core';
import { SuggestionProgressItem } from '../school-socio-emotional-dashboard-suggestions.models';
import { ApiService } from 'src/app/public/services/api.service';

const GET_EVIDENCE_URL = 'api/socioEmotionalSuggestionProgress/{suggestionId}/evidence/download';

@Component({
  selector: 'app-school-socio-emotional-dashboard-suggestions-card',
  templateUrl: './school-socio-emotional-dashboard-suggestions-card.component.html',
  styleUrls: ['./school-socio-emotional-dashboard-suggestions-card.component.scss']
})
export class SchoolSocioEmotionalDashboardSuggestionsCardComponent {
  @Input() suggestion!: SuggestionProgressItem;
  constructor(private apiService: ApiService) { }

  downloadEvidence(): void {
    const suggestionId = this.suggestion.suggestionProgressId;

    this.apiService
      .get({ api: GET_EVIDENCE_URL.replace('{suggestionId}', suggestionId) })
      .subscribe({
        next: (res: { url: string }) => {
          const link = document.createElement('a');
          link.href = res.url;
          link.target = '_blank';
          link.download = '';
          link.click();
        },
        error: (err) => {
          console.error('Error al obtener la URL de descarga:', err);
        }
      });
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('es-CO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  isImage(url: string): boolean {
    return /\.(jpg|jpeg|png)$/i.test(url);
  }
}

